import React from 'react';
import {
  KubernetesActionType,
  KubernetesAction,
  KubernetesResourceType,
} from './types';
import { ActionConfirmationDisplay } from '../../types';
import { ActionConfirmationDialog } from '../../ActionConfirmationDialog';

interface ConfirmationDialogProps {
  open: boolean;
  onClose: () => void;
  onConfirm: () => void;
  action: KubernetesActionType;
  isLoading: boolean;
  service: KubernetesResourceType;
}

interface DialogConfig {
  title: string;
  content: string;
  actionDisplay: ActionConfirmationDisplay;
}

const getDialogConfig = (
  action: KubernetesActionType,
  service: KubernetesResourceType,
): DialogConfig => {
  switch (service) {
    case 'resources': {
      const actionDisplays: Record<
        KubernetesAction,
        ActionConfirmationDisplay
      > = {
        start: { text: 'Start', color: 'primary' },
        stop: { text: 'Stop', color: 'secondary' },
        restart: { text: 'Restart', color: 'primary' },
        'enable-schedule': { text: 'Enable Schedule', color: 'primary' },
        'disable-schedule': { text: 'Disable Schedule', color: 'secondary' },
        'add-schedule': { text: 'Add Schedule', color: 'primary' },
        'update-schedule': { text: 'Update Schedule', color: 'primary' },
        'delete-schedule': { text: 'Delete Schedule', color: 'secondary' },
      };
      const actionDisplay = actionDisplays[action as KubernetesAction];
      const title = `Confirm ${actionDisplay.text} Kubernetes Resources`;
      const content = `Are you sure you want to ${actionDisplay.text.toLowerCase()} Kubernetes Resources?`;
      return { title, content, actionDisplay };
    }
    default: {
      return {
        title: 'Confirm',
        content: `Are you sure you want to execute ${action} action?`,
        actionDisplay: { text: action, color: 'primary' },
      };
    }
  }
};

export const KubernetesActionConfirmationDialog: React.FC<
  ConfirmationDialogProps
> = ({ open, onClose, onConfirm, action, isLoading, service }) => {
  if (!action) {
    return null;
  }

  const { title, content, actionDisplay } = getDialogConfig(action, service);

  return (
    <ActionConfirmationDialog<KubernetesActionType>
      open={open}
      onClose={onClose}
      onConfirm={onConfirm}
      action={action}
      isLoading={isLoading}
      actionDisplay={actionDisplay}
      title={title}
      content={content}
    />
  );
};
